
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { loading: false, data: [], error: "", message: "" }


export const updateSupportDataAction = createAsyncThunk(
    'update-support-data',
    async (data = null, { rejectWithValue }) => {
        try {
            const res = await axios.put(`/admins/api/support-knowladge`,data)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const updateSupportDataSlice = createSlice({
    name: 'update-support-data',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(updateSupportDataAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(updateSupportDataAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.message = action?.payload?.message
                state.status=action?.payload?.status
            })
            builder.addCase(updateSupportDataAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.message = action?.payload?.message
                state.status=action?.payload?.status

            })
        },

})



export const updateSupportDataReducer = updateSupportDataSlice.reducer    






// router.get("/support-knowladges/:page/:limit/:is_deleted", new SupportKnowladge().supportKnowladgeList)
// router.get("/support-knowladge/:id", new SupportKnowladge().supportKnowladgeDetail)
// router.post("/support-knowladge", new SupportKnowladge().createSupportKnowladge)
// router.put("/support-knowladge", new SupportKnowladge().updateSupportKnowladge)
// router.delete("/support-knowladge", new SupportKnowladge().deleteAndResoteSupportKnowladge)